module.exports = __webpack_public_path__ + "static/media/alarm.2b6e03d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/alarm.svg
// module id = 310
// module chunks = 0